import styles from './PageHeader.module.scss';

type Props = {
  text: string;
  centered?: boolean;
  sideNode?: React.ReactNode;
  level?: 1 | 2;
};

function PageHeader({ text, centered = false, sideNode, level = 1 }: Props) {
  const HTag = `h${level}` as const;
  return (
    <div className={headerWrapperClass({ centered, sideNode })}>
      <HTag className={styles.title}>{text}</HTag>
      {sideNode}
    </div>
  );
}

function headerWrapperClass({ centered, sideNode }: Pick<Props, 'centered' | 'sideNode'>) {
  if (sideNode) return styles.spaceBetween;
  if (centered) return styles.centered;
  return '';
}

export default PageHeader;
